import { generateUrl } from '@/utils/generate-url'

export function resolvePctLinkUrl(
  link: Queries.PctLinkFragment | null,
  absolute = false
): string {
  if (link == null) return ''
  const { content, url, hash, linkMedia, linkType } = link

  if (linkType === 'url' && url !== null && url !== '') {
    return url
  }

  if (linkType === 'asset' && linkMedia?.url != null) {
    return linkMedia.url ?? ''
  }

  if (linkType === 'content' && content != null) {
    const slug = 'slug' in content ? content.slug : ''
    return generateUrl(content.__typename, slug ?? '', absolute, hash ?? '')
  }

  return ''
}
